import { newSpecPage } from '@stencil/core/testing';
import { BdButton } from '../bd-button';

describe('bd-button', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [BdButton],
      html: `<bd-button></bd-button>`,
    });
    expect(page.root).toEqualHtml(`
      <bd-button>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </bd-button>
    `);
  });
});
